import {
  isWeex,
  isReactNative,
} from "../utils/env";
import {debounce} from '../utils/index'
import {ErrorType, WeexLogUtil} from './weex'


class ErrorLog {
  constructor(hawkEyeStat) {
    if (Object.prototype.toString.call(hawkEyeStat) === "[object Function]") {
      this.hawkEyeStat = hawkEyeStat;
    } else {
      this.hawkEyeStat = () => false;
    }
  }

  log(params, options = {}) {
    try {
      if ((isWeex || isReactNative) && Object.prototype.toString.call(params) === "[object Object]") {
        let type = params.statType
        // type错误直接返回
        if (!type) {
          return false
        }
        let fun = () => {
          return this.hawkEyeStat(params)
        }
        if (options && options.isForce) {
          return fun()
        } else {
          let count = 2
          return debounce(fun, type, count)
        }
      }
    } catch (error) {
      console.log('上报信息有误')
    }
  }
}

WeexLogUtil._ErrorLogClass = ErrorLog;

export {ErrorType, WeexLogUtil};

export default ErrorLog;
